/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailMeasurement_measurements = $ReadOnlyArray<{|
  +unit: ?string;
  +value: ?string;
|}>;
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedDetailMeasurement_measurements",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "unit",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "ItemDisplayMeasurementType"
};

module.exports = fragment;
